// pages/.../WarehouseCreate.tsx
import React, { useContext, useEffect, useState } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { AppContext } from '../../../contexts/AppContext';
import { toast } from 'react-toastify';
import useWarehouseService from '../../../app/services/hooks/useWarehouseService';
import { WarehouseDataForm } from '../../../app/models/Warehouse';
import ButtonCancelForm from '../../../components/buttons/ButtonCancelForm';
import ButtonSaveForm from '../../../components/buttons/ButtonSaveForm';
import WarehouseForm from './forms/WarehouseForm';

interface Props {
  onSaved?: () => void;
  onCancel?: () => void;
  onError?: () => void;
}

type SelectOpt = { id: number | string; name: string };

const WarehouseCreate = ({ onSaved, onCancel, onError }: Props) => {
  const { showLoading, hideLoading } = useContext(AppContext);
  const { createWarehouse, storeWarehouse, fetchingStoreWarehouse } = useWarehouseService();
  const handleCancel = onCancel ?? (() => undefined);
  const [warehouse, setWarehouse] = useState<WarehouseDataForm>({
    warehouse_type: 'COLLECTION_YARD',
    name: '',
    address: '',
    center_id: null,
    used_capacity: 0,
    is_active: true
  });

  const [centers, setCenters] = useState<SelectOpt[]>([]);
  const [warehouseTypes, setWarehouseTypes] = useState<SelectOpt[]>([]);
  const [errorFields, setErrorFields] = useState<any>();

  useEffect(() => { create(); }, []);

  const create = () => {
    showLoading?.('loading', 'Cargando formulario...');
    createWarehouse({
      onSuccess: (response: ServiceResponse) => {
        setCenters(response.data.centers || []);
        setWarehouseTypes(response.data.warehouse_types || []);
        hideLoading?.();
      },
      onError: (response: ServiceResponse) => {
        hideLoading?.();
        toast.error(response.message);
        onError && onError();
      }
    });
  };

  const store = () => {
    const requiredErrors: Record<string, string[]> = {};
    if (warehouse.center_id == null || warehouse.center_id === 0) {
      requiredErrors.center_id = ['El centro es obligatorio.'];
    }
    if (!warehouse.warehouse_type?.trim()) {
      requiredErrors.warehouse_type = ['El tipo de almacén es obligatorio.'];
    }
    if (!warehouse.name?.trim()) {
      requiredErrors.name = ['Este campo no puede estar vacío.'];
    }
    if (Object.keys(requiredErrors).length > 0) {
      setErrorFields(requiredErrors);
      return;
    }

    setErrorFields(undefined);
    showLoading?.('loading', 'Guardando almacén...');
    storeWarehouse(warehouse, {
      onSuccess: (response: ServiceResponse) => {
        hideLoading?.();
        toast.success(response.message, { autoClose: 2500 });
        onSaved && onSaved();
      },
      onError: (response: ServiceResponse) => {
        hideLoading?.();
        toast.error(response.message);
      },
      onFieldError: (errs: ServiceResponse) => {
        hideLoading?.();
        setErrorFields(errs.data);
      }
    });
  };

  return (
    <>
      <div className="row"><div className="col-12">
        <WarehouseForm
          warehouseDataForm={warehouse}
          setWarehouseDataForm={setWarehouse}
          centers={centers}
          warehouseTypes={warehouseTypes}
          errorFields={errorFields}
        />
      </div></div>
      <hr />
      <div className="row justify-content-end">
        <div className="col-auto">
          <ButtonCancelForm callbackCancel={handleCancel} locked={!!fetchingStoreWarehouse} />
        </div>
        <div className="col-auto">
          <ButtonSaveForm callbackSave={store} locked={!!fetchingStoreWarehouse} />
        </div>
      </div>
    </>
  );
};

export default WarehouseCreate;
